import { NotificationService } from '@app/services/notification.service';
import { delay, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { Component, OnInit, AfterViewInit, AfterViewChecked, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { PageEvent } from '@angular/material/paginator';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as json2csv from 'json2csv'; // convert json file to csv
import { Parser } from 'json2csv';
const { transforms: { unwind } } = require('json2csv');

//const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-descargar-datos',
  templateUrl: './descargar-datos.component.html',
  styleUrls: ['./descargar-datos.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DescargarDatosComponent implements OnInit, OnDestroy {

  zarpes: any[] = [];
  cargaZarpes: any[] = [];
  fechaInicial = new FormControl();
  fechaFinal = new FormControl();
  f1 ='';
  f2: String;
  public month: number = new Date().getMonth();
  public fullYear: number = new Date().getFullYear();
  loading = false;
  GQL: any;
  private querySubscription: Subscription;
  Json2csvParser = json2csv.Parser;
  fields =  ['numero', 'numeroViaje', 'fecha','hora', 'estadoZarpe','embarcacion.nombre', 'modalidadTransporte.nombre','puertoOrigen.nombre', 'puertoDestino.nombre','usuarioRegistradorCodigo','carga.zarpeNumero', 'carga.embarcacionNic', 'carga.cantidadCarga','carga.producto.nombre','carga.puertoDestino.nombre','carga.puertoOrigen.nombre'];
  @ViewChild('content') content: ElementRef;
    constructor(private apollo: Apollo,
    private notificationService: NotificationService,) { }

  ngOnInit(): void {
    this.fechaFinal.setValue( new Date ());
    this.fechaInicial.setValue( new Date(this.fullYear, this.month , 1, 0,0,0));
  }

  DescargarDatosCSV(){
    console.log(this.zarpes);
    console.log(this.cargaZarpes);
    this.downloadFile(this.zarpes, 'zarpes',this.fields);
   // this.downloadFile(this.zarpes,'cargaZarpes',this.fieldsC)

  }


  //llamar datos
  loadQuery() {
  
    this.f1 = new Date(this.fechaInicial.value).toDateString();
    this.f2 = new Date(this.fechaFinal.value).toDateString();
    this.GQL = gql`
    query descargaZarpes{
      descargaZarpes (fechaInicial: "${this.f1}" fechaFinal: "${this.f2}"){
          numero
          numeroViaje
          fecha
          hora
          cantidadPasajeros
          estadoZarpe
          embarcacion{
            nic
            nombre
          }
          estadoZarpe
          modalidadTransporte{
            nombre
          }
          puertoOrigen {
            nombre
          }
          puertoDestino {
            nombre
          }
          usuarioRegistradorCodigo
          carga{
            zarpeNumero
            embarcacionNic
            cantidadCarga
            producto {
              nombre
              codigo
            }
            puertoDestino {
              nombre
              codigo
            }
            puertoOrigen {
              nombre
              codigo
            }
          }
      }
    }
  `;
  }

  traerZarpes(pageEvent: PageEvent = null) {
    this.loadQuery();
    this.loading = true;

    this.loadQuery();
    
    console.log('trayendo zarpes');
    this.querySubscription = this.apollo.watchQuery<any>({
      query: this.GQL,
    })
      .valueChanges.pipe(
        tap(() => console.log('Wait 5 seconds')),
        delay(500),
    ).subscribe(({ data, loading }) => {
      this.zarpes = data.descargaZarpes;
      this.cargaZarpes = data.descargaZarpes.carga;
      this.loading = false;
      console.log('Zarpes traidos');
      this.notificationService.showNotification('Muy bien!', 'Datos traídos', 'success');
    },
      (error) => {
        console.log(error);
        this.notificationService.showNotification('Datos invalidos', 'Datos invalidos', 'warning');
      });
  }

  downloadFile(data, filename='data', fieldsp) {
    let csvData = this.convertToCSVE(data, fieldsp);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

public convertToCSVE(objArray: any, fields?) {
  const transforms = [unwind({paths:['carga','carga.carga'], blankOut: true })];
  let json2csvParser = new Parser({ fields, transforms });
  let csv = json2csvParser.parse(objArray);
  console.log(csv);
  return csv;
}

public ngOnDestroy() {
    console.log('destroying');
   /* this.querySubscription.unsubscribe();*/
  }

}
